import { fetchArrears } from './queries/fetchArrears';
import { getUserPayrollMonthsByFilter } from './queries/getUserPayrollMonthsByFilter';
import { bulkPreviewArrears } from './mutations/bulkPreviewArrears';
import { bulkDeleteArrears } from './mutations/bulkDeleteArrears';
import { saveArrears } from './mutations/saveArrears';

const queries = {
  fetchArrears,
  getUserPayrollMonthsByFilter,
};

const mutations = {
  bulkPreviewArrears,
  bulkDeleteArrears,
  saveArrears,
};

const arrearsGql = {
  queries,
  mutations,
};

export default arrearsGql;
